import { render, staticRenderFns } from "./product-review-modal.component.vue?vue&type=template&id=8e742bb6&"
import script from "./product-review-modal.component.vue?vue&type=script&lang=ts&"
export * from "./product-review-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./product-review-modal.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "product-review-modal.component.vue"
export default component.exports